import { LastLinkTypes } from './types';

export const addNewLink = () => {
  const link = window.location.pathname;
  return {
    type: LastLinkTypes.NEW_LAST_LINK,
    link,
  };
};
